import _ from 'lodash';
import React, { Component } from 'react';
import Cropper from 'react-cropper';
import autobind from 'autobind-decorator';
import { observer } from 'mobx-react';

@observer
class ImageUpload extends Component {
	constructor(props) {
		super(props);

		this.state = {
			src: '',
			cropResult: null,
		};
	}

	componentDidMount () {
		const { imgSrc, store, item } = this.props;

		let uploadFile;

		if (_.isObject(item)) {

			uploadFile = item.uploadFile;
		} else {

			uploadFile = store.get('editImage.uploadImage') || [];
		}

		if (_.isObject(uploadFile)) {

			this.readFile(uploadFile);
			return;
		}

		this.setState({
			src: imgSrc
		});
	}

	@autobind
	onChange (evt) {
		evt.preventDefault();
		const { dataTransfer, target } = evt;
		let files;

		if (dataTransfer) {

			files = dataTransfer.files;
		} else if (target) {

			files = target.files;
		}

		this.readFile(_.first(files));
	}

	readFile (file) {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = (e) => {
			let checkImage = new Image(); 
			checkImage.src = e.target.result;
			checkImage.onload = (i) => {
				console.log(i.target.width)
				console.log(i.target.height)
				//TODO: Check image limits here.
			}
			this.setState({ src: reader.result });
		};

		// reader.readAsDataURL(file);
	}

	@autobind
	cropImage () {
		const { height = 400, width = 400 } = this.props;
		const croppedCanvas = this.cropper.getCroppedCanvas({
			width, height
		});//'image/jpeg', 0.9);

		if (_.isUndefined(croppedCanvas)) {

			return;
		}

		const cropResult = croppedCanvas.toDataURL();
		this.props.handleImageCrop(cropResult);
		this.setState({ cropResult });
	}

	render () {
		const {
			item,
			height = "800px",
			width = "800px",
			aspectRatio = 1,
			imgClassName = 'image large',
			mode
		} = this.props;

		return (
			<div>
				<div className="grid-x grid-padding-x margin-top-1">
					<div className="cell small-6">
						<h4>Crop Image</h4>
						<Cropper
							style={{
								height: `${height}`,
								width: `${width}`,
							}}
							aspectRatio={ aspectRatio }
							preview=".img-preview"
							guides={ false }
							src={ this.state.src }
							crossOrigin="anonymous"
							ref={ (cropper) => { this.cropper = cropper; } }
						/>


					</div>

					<div className="cell small-6">
						{mode !== 'banner' && (<h4>Cover Image Preview</h4>)}
						{mode === 'banner' && (<h4>Banner Image Preview</h4>)}
						<div className={ `img-preview ${imgClassName}` } style={{
							overflow: 'hidden',
							width: '28.3vw',
							height: '9rem',
							}}></div>
						<div className="margin-top-3">
							<label htmlFor="imageUpload" className="button minor padding-left-0">
								Choose New Image
							</label>
							{mode === 'banner' && (
								<p><i>(Your banner image should be at least 2000 x 1000 pixels large.)</i></p>
							)}
							<input
								type="file"
								accept=".png, .jpg, .jpeg"
								id="imageUpload"
								data-ta="imageUpload"
								className="show-for-sr"
								onChange={ this.onChange }
							/>
							<div className="grid-x grid-padding-x">
								<div className="cell auto">
									{ this.props.children || null }
									<button className="button neo" onClick={ this.cropImage }>
										Save Image
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>
		);
	}
}

export default ImageUpload;
